import React from 'react';
import { Card } from '../ui/card';
import { Progress } from '../ui/progress';
import { Building2, FileText, AlertCircle } from 'lucide-react';
import { formatDate } from '../../lib/utils';

const StatBlock = ({ value, label, color }) => (
  <div>
    <p className={`text-2xl font-bold ${color || ''}`}>{value || 0}</p>
    <p className="text-xs text-muted-foreground">{label}</p>
  </div>
);

export const ProjectProgressCard = ({ stats }) => (
  <Card className="lg:col-span-3 p-6">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-heading font-semibold">Project Completion</h3>
      <span className="text-2xl font-bold text-primary">{stats?.completion_percentage || 0}%</span>
    </div>
    <Progress value={stats?.completion_percentage || 0} className="h-3 mb-4" />
    <div className="grid grid-cols-5 gap-4 text-center">
      <StatBlock value={stats?.total_tasks} label="Total" />
      <StatBlock value={stats?.not_started} label="Not Started" color="text-muted-foreground" />
      <StatBlock value={stats?.in_progress} label="In Progress" color="text-blue-500" />
      <StatBlock value={stats?.under_review} label="Under Review" color="text-purple-500" />
      <StatBlock value={stats?.completed} label="Completed" color="text-green-500" />
    </div>
  </Card>
);

export const ProjectDetailsCard = ({ project, linkedProposal, stats, canSeeBudget, navigate }) => (
  <Card className="p-6">
    <h3 className="text-lg font-heading font-semibold mb-4">Details</h3>
    <div className="space-y-3">
      {project.client_name && (
        <div>
          <p className="text-xs text-muted-foreground">Client</p>
          <p className="text-sm font-medium">{project.client_name}</p>
        </div>
      )}
      {project.company_name && (
        <div>
          <p className="text-xs text-muted-foreground">Company</p>
          <p className="text-sm font-medium flex items-center gap-1">
            <Building2 className="h-3 w-3" />{project.company_name}
          </p>
        </div>
      )}
      {canSeeBudget && project.budget && (
        <div>
          <p className="text-xs text-muted-foreground">Budget</p>
          <p className="text-lg font-bold">INR {project.budget.toLocaleString('en-IN')}</p>
        </div>
      )}
      {linkedProposal && (
        <div>
          <p className="text-xs text-muted-foreground">Linked Proposal</p>
          <button
            onClick={() => navigate(`/proposals/${linkedProposal.proposal_id}`)}
            className="text-sm font-medium text-primary hover:underline flex items-center gap-1"
            data-testid="linked-proposal-link"
          >
            <FileText className="h-3 w-3" />
            {linkedProposal.title}
          </button>
        </div>
      )}
      {project.start_date && (
        <div>
          <p className="text-xs text-muted-foreground">Start Date</p>
          <p className="text-sm font-medium">{formatDate(project.start_date)}</p>
        </div>
      )}
      {project.end_date && (
        <div>
          <p className="text-xs text-muted-foreground">End Date</p>
          <p className="text-sm font-medium">{formatDate(project.end_date)}</p>
        </div>
      )}
      {stats?.overdue > 0 && (
        <div className="flex items-center gap-2 text-red-500">
          <AlertCircle className="h-4 w-4" />
          <span className="text-sm font-medium">{stats.overdue} Overdue</span>
        </div>
      )}
    </div>
  </Card>
);
